export default "__VITE_ASSET__C8Z6H086__"